<template>
  <aside :class="mobileSideBar ? 'active' : ''">
    <div class="sidebar">
      <ul>
        <li>
          <div class="home">
            <img src="../assets/images/buying-a-home-ico.svg" alt="home icon" />
          </div>
          {{
            getAppFlow === "Refinance"
              ? translatedData?.titleRefinance
              : translatedData?.titleBuying
          }}
        </li>
        <template v-if="sidebarSections && sidebarSections.length">
          <li
            v-for="(section, index) in sidebarSections"
            :key="index"
            :class="
              section.completed
                ? 'completed'
                : section.visited && !section.completed
                ? 'incomplete'
                : section.sectionName === getActiveSection
                ? 'current'
                : ''
            "
          >
            <div class="icon"></div>
            <div class="icon-text cursor-pointer">
              <span @click="startOfSection(section)"
                >{{ section?.translatedSectionName }}
                <i v-show="section.visited || section.completed" class="edit-icon"
                  ><img
                    src="../assets/images/edit-white-icon.svg"
                    alt="edit icon"
                /></i>
              </span>
              <a
                v-if="
                  showSidebarLink && section.sectionName === 'Real Estate Owned'
                "
                class="mt-1 extra-link"
                @click="forceAddProperty"
                >{{ translatedData?.addProperty }}</a
              >
              <ul v-show="section.visited || section.completed">
                <template v-for="ques in sidebarQues">
                  <li
                    :key="ques.questionIndex"
                    v-if="
                      ques.sectionName === section.sectionName &&
                      ques.showOnSidebar &&
                      (ques.apiName === 'AddressAPI' ||
                        ques.apiName === 'EmploymentInfo') &&
                      checkQueDependancy(ques) &&
                      isFirstApiQuestionInSection(ques)
                    "
                    @click="redirectToTheQuestion(ques)"
                  >
                    <template v-if="skipTheFields(ques).length">
                      <!-- Content for Address -->
                      <template v-if="ques.apiName === 'AddressAPI'">
                        <span v-if="typeof formTheAddresses(ques) === 'string'"
                          >{{
                            ques?.sidebarAbbreviationText
                              ? ques.sidebarAbbreviationText + ":"
                              : "- "
                          }}
                          <strong class="px-2">{{
                            formTheAddresses(ques)
                          }}</strong></span
                        >
                        <span
                          v-else-if="
                            !formTheAddresses(ques) && ques.isMandatory
                          "
                          >{{
                            ques?.sidebarAbbreviationText
                              ? ques.sidebarAbbreviationText + ":"
                              : "- "
                          }}
                          <strong class="sidebar-missed"
                            >{{ translatedData?.missed || 'missed' }}</strong
                          ></span
                        >
                        <ul v-else-if="typeof formTheAddresses(ques) === 'object'">
                          <li
                            v-for="(address, index) in formTheAddresses(ques)"
                            :key="index"
                          >
                            {{
                              ques?.sidebarAbbreviationText
                                ? ques.sidebarAbbreviationText + ":"
                                : "- "
                            }}
                            <strong class="px-2">{{ address }}</strong
                            ><br />
                          </li>
                        </ul>
                      </template>

                      <!-- Content for Employment -->
                      <template v-if="ques.apiName === 'EmploymentInfo'">
                        <span v-if="formTheEmployment(ques)"
                          >{{ fetchTheAbbreviation(ques) }}
                          <strong class="px-2">{{
                            formTheEmployment(ques)
                          }}</strong></span
                        >
                        <span v-else-if="ques.isMandatory"
                          >{{ fetchTheAbbreviation(ques) }}
                          <strong class="sidebar-missed"
                            >{{ translatedData?.missed || 'missed' }}</strong
                          ></span
                        >
                      </template>
                    </template>
                    <template v-else>
                      <span
                        v-if="
                          ques.isMandatory &&
                          ((ques.apiName === 'AddressAPI' && !formTheAddresses(ques)) ||
                           (ques.apiName === 'EmploymentInfo' && !formTheEmployment(ques)))
                        "
                      >
                        {{
                          ques?.translatedSidebarAbbreviationText ||
                          ques?.sidebarAbbreviationText
                            ? (ques?.translatedSidebarAbbreviationText || ques?.sidebarAbbreviationText) + ":"
                            : "- "
                        }}
                        <strong class="sidebar-missed">{{ translatedData?.missed || 'missed' }}</strong>
                      </span>
                    </template>
                  </li>
                  <template
                    v-else-if="
                      checkQueDependancy(ques) &&
                      ques.apiName !== 'AddressAPI' &&
                      ques.apiName !== 'EmploymentInfo'
                    "
                  >
                    <li
                      :key="ques.questionIndex"
                      v-if="
                        ques.sectionName === section.sectionName &&
                        ques.showOnSidebar &&
                        ques.questionType !== 'MultipleChoice'
                      "
                      @click="redirectToTheQuestion(ques)"
                    >
                      <template v-if="skipTheFields(ques).length">
                        <span v-if="ques.questionAnswer"
                          >{{ ques?.translatedSidebarAbbreviationText }}:
                          <strong class="px-2">{{
                            mergeTheAbbreviationText(ques)
                          }}</strong></span
                        >
                        <span v-else-if="ques.isMandatory">
                          {{ ques?.translatedSidebarAbbreviationText || ques?.sidebarAbbreviationText }}<template v-if="ques?.translatedSidebarAbbreviationText || ques?.sidebarAbbreviationText">:</template>
                          <strong class="sidebar-missed"
                            >{{ translatedData?.missed || 'missed' }}</strong
                          >
                        </span>
                      </template>
                      <template v-else>
                        <span v-if="ques.questionAnswer">
                          {{ ques?.translatedSidebarAbbreviationText }}:
                          <strong class="px-2">{{
                            ques?.questionAnswer
                          }}</strong>
                        </span>
                        <span v-else-if="ques.isMandatory">
                          {{ ques?.translatedSidebarAbbreviationText || ques?.sidebarAbbreviationText }}<template v-if="ques?.translatedSidebarAbbreviationText || ques?.sidebarAbbreviationText">:</template>
                          <strong class="sidebar-missed"
                            >{{ translatedData?.missed || 'missed' }}</strong
                          >
                        </span>
                      </template>
                    </li>
                    <li
                      :key="ques.questionIndex"
                      v-if="
                        ques.sectionName === section.sectionName &&
                        ques.showOnSidebar &&
                        ques.questionType === 'MultipleChoice'
                      "
                      @click="redirectToTheQuestion(ques)"
                    >
                      <template v-if="ques.questionAnswer && ques.questionAnswer.length">
                        <ul>
                          <li
                            v-for="(q, i) in ques.questionAnswer"
                            :key="i"
                            @click="redirectToTheQuestion(ques)"
                          >
                            <span>
                              {{ q }}:
                              <strong class="px-2">{{
                                getSubQuestionsAnswers(ques, q) | formatNumber
                              }}</strong>
                            </span>
                          </li>
                        </ul>
                      </template>
                      <template v-else-if="ques.isMandatory">
                        <span style="display: inline">
                          {{ ques?.translatedQuestionText || ques?.questionText }}:&nbsp;<strong class="sidebar-missed" style="white-space: nowrap">{{ translatedData?.missed || 'missed' }}</strong>
                        </span>
                      </template>
                    </li>
                  </template>
                </template>
              </ul>
            </div>
          </li>
        </template>
      </ul>
      <!-- User Info -->
      <div v-if="getIsAuthenticated" class="user-info">
        <!-- Steven changes starts - DMA co-brand: with a realtor, the LO and the realtor use the mockup's compact layout (photo, name + role, phone, email); without one, the LO block below is unchanged -->
        <div v-if="hasCoBrandRealtor" class="cobrand-contacts">
          <div class="cobrand-contact">
            <div class="avatar">
              <img
                v-if="getUser?.profilePhotoURL"
                :src="getUser?.profilePhotoURL"
                alt="Profile-Image"
              />
              <img
                v-else
                src="../assets/images/user-avatar.png"
                alt="Profile-Image"
              />
            </div>
            <div class="cobrand-contact__details">
              <p class="cobrand-contact__name">
                {{ getUser?.name }}<span class="cobrand-contact__role">{{ translatedData?.loTitle }}</span>
              </p>
              <a v-if="getUser?.phone" :href="`tel:${getUser?.phone}`">{{ getUser?.phone }}</a>
              <a v-if="getUser?.email" :href="`mailto:${getUser?.email}`">{{ getUser?.email }}</a>
            </div>
          </div>
          <div class="cobrand-contact">
            <div class="avatar">
              <img :src="getUser.realtorHeadshot" alt="Realtor-Image" />
            </div>
            <div class="cobrand-contact__details">
              <p class="cobrand-contact__name">
                {{ getUser.realtorName }}<span class="cobrand-contact__role">{{ translatedData?.realtorTitle }}</span>
              </p>
              <a v-if="getUser.realtorPhone" :href="`tel:${getUser.realtorPhone}`">{{ getUser.realtorPhone }}</a>
              <a v-if="getUser.realtorEmail" :href="`mailto:${getUser.realtorEmail}`">{{ getUser.realtorEmail }}</a>
            </div>
          </div>
        </div>
        <template v-else>
        <!-- Steven changes ends -->
        <div class="avatar-name">
          <div class="avatar">
            <img
              v-if="getUser?.profilePhotoURL"
              :src="getUser?.profilePhotoURL"
              alt="Profile-Image"
            />
            <img
              v-else
              src="../assets/images/user-avatar.png"
              alt="Profile-Image"
            />
          </div>
          <div class="name-contact">
            <h4>{{ getUser?.name }}</h4>
            <span v-if="getUser?.title">{{ getUser?.title }}</span>
          </div>
        </div>
        <ul class="mb-2">
          <li v-if="getUser?.phone">
            <img src="../assets/images/call-icon.svg" alt="Phone-Icon" /><a
              :href="`tel:${getUser?.phone}`"
            >
              {{ getUser?.phone }}</a
            >
          </li>
          <li v-if="getUser?.email">
            <img src="../assets/images/mail-icon.svg" alt="Mail-Icon" /><a
              :href="`mailto:${getUser?.email}`"
            >
              {{ getUser?.email }}</a
            >
          </li>
        </ul>
        <!-- Steven changes starts - DMA co-brand: end of the no-realtor LO block -->
        </template>
        <!-- Steven changes ends -->
        <div class="lo-other-details">
          <p v-if="fetchUserData?.nmls" class="mb-2">
            {{ translatedData?.nmls }}: {{ getUser?.nmls }}
          </p>
          <div class="sub-details">
            <p>
              {{ translatedData?.licenceInfo }}
              <a href="https://www.nmlsconsumeraccess.org/" target="_blank"
                >www.nmlsconsumeraccess.org</a
              >
            </p>
            <svg
              v-if="getUser?.equalHousingLogo"
              width="50"
              height="50"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.1719 37.0848H18.1579L16.0642 32.7821H14.9037V38.9595H15.9311V34.5548H15.9463L18.0983 38.9595H19.2008V32.7821H18.1719V37.0848ZM13.2442 28.4479L12.2942 31.7509H12.8809L13.0664 31.0709H14.0495L14.2206 31.7509H14.8245L13.8865 28.4479H13.2442ZM13.2143 30.4999L13.555 29.1939H13.5636L13.8931 30.4999H13.2143ZM9.37779 30.1003C9.37779 28.5489 8.45036 28.3619 8.09684 28.3619C7.74553 28.3619 6.81662 28.5489 6.81662 30.1003C6.81662 31.6502 7.74553 31.8384 8.09684 31.8384C8.25325 31.8384 8.52783 31.8014 8.78034 31.6171L9.09512 31.9899L9.38809 31.6171L9.09904 31.2763C9.26232 31.0189 9.37779 30.6413 9.37779 30.0995V30.1003ZM8.69895 30.8088L8.41652 30.4812L8.1314 30.8551L8.39863 31.1667C8.29836 31.2319 8.19098 31.2542 8.09708 31.2542C7.7975 31.2542 7.37387 31.0248 7.37387 30.1008C7.37387 29.1753 7.7975 28.9458 8.09708 28.9458C8.39863 28.9458 8.82103 29.1753 8.82103 30.1008C8.82079 30.4121 8.77323 30.6401 8.69895 30.8117V30.8088ZM15.1819 28.4479V31.7509H17.062V31.153H15.7389V28.4482L15.1819 28.4479ZM21.0883 31.7502H21.643V28.4472H21.0883V29.6977H20.048V28.4472H19.4913V31.7502H20.048V30.2692H21.0883V31.7502ZM10.6428 36.2684H13.213V35.1746H10.6428V33.8752H13.441V32.7825H9.56215V38.96H13.5663V37.8688H10.6428V36.268V36.2684ZM6.42045 29.0338V28.4491H4.46139V31.7521H6.48272V31.1672H5.00564V30.3121H6.30498V29.7286H5.00564V29.0338H6.42045ZM5.68448 32.7823H4.58323V38.9598H8.30767V37.8419H5.68448V32.7818V32.7823ZM9.80804 28.4479V30.6372C9.81466 30.9686 9.87031 31.2363 10.0154 31.4381C10.2535 31.7642 10.6168 31.8384 10.8615 31.8384C11.5337 31.8384 11.9561 31.4658 11.9561 30.5962V28.4482H11.3886V30.6239C11.3886 31.0245 11.2322 31.2537 10.8509 31.2537C10.5918 31.2537 10.3758 31.051 10.3758 30.5921V28.4482L9.80804 28.4479ZM30.1868 31.7502H30.7436V28.4472H30.1868V31.7494V31.7502ZM36.1172 37.5678C36.1172 36.4128 35.8811 36.2246 35.4477 36.0005C35.9696 35.7936 36.2638 35.2089 36.2638 34.5286C36.2638 33.9956 36.0059 32.7823 34.6038 32.7823H31.9368V38.9598H33.0159V36.5413H34.1554C34.9696 36.5413 35.0147 36.8688 35.0147 37.7119C35.0147 38.3486 35.0586 38.6678 35.1314 38.9598H36.352V38.7968C36.1142 38.6889 36.1142 38.4658 36.1142 37.5636L36.1172 37.5678ZM34.3104 35.5011H33.0164V33.8492H34.3908C35.037 33.8492 35.1618 34.3305 35.1618 34.658C35.1594 35.2709 34.8823 35.5013 34.3087 35.5013L34.3104 35.5011ZM28.7159 31.2672C28.23 31.2672 28.1557 30.9186 28.151 30.7355H27.6178C27.6178 31.1439 27.7843 31.8387 28.7568 31.8387C28.9902 31.8387 29.8063 31.7514 29.8063 30.7568C29.8063 30.164 29.4722 29.9799 29.1081 29.8698L28.4592 29.6722C28.3479 29.6389 28.1782 29.5847 28.1782 29.3275C28.1782 29.0292 28.4295 28.9323 28.6418 28.9323C29.1275 28.9323 29.1728 29.2812 29.1875 29.4283H29.7213C29.7186 29.0226 29.4984 28.3621 28.6825 28.3621C27.8181 28.3621 27.6587 29.0093 27.6587 29.3778C27.6587 30.1044 28.0743 30.2251 28.5045 30.3484L28.7897 30.4307C29.0721 30.5143 29.2731 30.5832 29.2731 30.8404C29.278 31.1934 28.9838 31.2694 28.719 31.2694L28.7159 31.2672ZM33.4057 31.7502V28.4472H32.886V30.7477H32.8796L31.8215 28.4472H31.2349V31.7502H31.7551V29.3954H31.7617L32.849 31.7502H33.4055H33.4057ZM35.1537 28.9333C35.5474 28.9333 35.7377 29.3471 35.7377 29.4744H36.2927C36.2643 29.0196 35.9412 28.3633 35.1253 28.3633C34.2263 28.3582 33.822 29.2091 33.822 30.1108C33.822 31.2684 34.404 31.8399 35.0463 31.8399C35.5322 31.8399 35.7377 31.5403 35.8779 31.3373L35.9336 31.7524H36.3057V29.9716H35.192V30.5283H35.811C35.6955 31.1954 35.2886 31.255 35.166 31.255C34.7872 31.255 34.391 31.0216 34.391 30.1199C34.391 29.2716 34.7566 28.9333 35.1537 28.9333ZM27.2106 30.5955V28.4474H26.643V30.6232C26.643 31.0238 26.4874 31.253 26.1057 31.253C25.8451 31.253 25.6303 31.0503 25.6303 30.5913V28.4474H25.063V30.6367C25.0694 30.9681 25.1253 31.2358 25.2711 31.4376C25.5087 31.7637 25.871 31.838 26.1165 31.838C26.7877 31.8404 27.2118 31.4678 27.2118 30.5975L27.2106 30.5955ZM27.6249 36.2684H30.1964V35.1746H27.6249V33.8752H30.4231V32.7825H26.5457V38.96H30.5479V37.8688H27.6249V36.268V36.2684ZM24.6318 30.1003C24.6318 28.5489 23.7029 28.3619 23.3513 28.3619C22.998 28.3619 22.0706 28.5489 22.0706 30.1003C22.0706 31.6502 22.9978 31.8384 23.3513 31.8384C23.7029 31.8384 24.6318 31.6497 24.6318 30.1003ZM22.6278 30.1003C22.6278 29.1748 23.0515 28.9453 23.3516 28.9453C23.6514 28.9453 24.075 29.1748 24.075 30.1003C24.075 31.0245 23.6511 31.2537 23.3516 31.2537C23.0512 31.2537 22.6278 31.0233 22.6278 30.099V30.1003ZM23.0784 32.7823H20.7499V38.9598H23.0353C24.7754 38.9598 25.2236 37.049 25.2236 35.7247C25.2236 34.5553 24.8571 32.7828 23.0784 32.7828V32.7823ZM22.9022 37.8938H21.8296V33.85H22.8882C23.3582 33.85 24.0993 33.9958 24.0993 35.8201C24.0993 36.8375 23.7977 37.8941 22.9022 37.8941V37.8938ZM20.1076 1L3 9.75754V13.3216L4.89287 13.3469V26.1103H35.1944L35.1785 13.3219H37.2153V9.75828L20.1074 1.00074L20.1076 1ZM31.8196 22.7394H8.26404V11.3871L20.1079 5.27752L31.8186 11.3871V22.7394H31.8196ZM14.507 14.3704H25.606V11.305H14.507V14.3704ZM14.507 19.8836H25.5563V16.8181H14.507V19.8836Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="sidebar-legal-links">
        <router-link to="/terms-of-use">{{ translatedData?.termsOfUse }}</router-link>
        <span class="sidebar-legal-separator">|</span>
        <router-link to="/privacy-policy">{{ translatedData?.privacyPolicy }}</router-link>
      </div>
    </div>
  </aside>
</template>
<script>
const sidebarJson = {
  titleBuying: "Buying a home",
  titleRefinance: "Refinancing a home",
  addProperty: "Add a property",
  nmls: "NMLS",
  licenceInfo: "For licensing information visit",
  address: "Address",
  termsOfUse: "Terms of Use",
  privacyPolicy: "Privacy Policy",
  missed: "missed",
  // Steven changes starts - DMA co-brand labels
  realtorTitle: "Realtor®",
  loTitle: "Loan Officer",
  // Steven changes ends
};
import { mapActions, mapGetters } from "vuex";
import { eventBus } from "./../event-bus";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import { translateText } from "../translate-service";
import { sideBartranslationMixin } from "../mixins/sidebarMixin";
import { addressTranslationMixin } from "../mixins/addressMxin";
import { employmentTranslationMixin } from "../mixins/employmentMixin";
import { translationMixin } from "../mixins/translationMixin";
export default {
  name: "Sidebar",
  mixins: [
    sideBartranslationMixin,
    addressTranslationMixin,
    translationMixin,
    employmentTranslationMixin,
  ],
  data() {
    return {
      sidebarSections: [],
      sidebarQues: [],
      mobileSideBar: false,
      isUpdating: false, // Flag to prevent loop
      fetchUserData: null,
      data: sidebarJson,
      isFirstLoad: true, // Flag to check if it's the first load
    };
  },
  computed: {
    ...mapGetters([
      "getOrgId",
      "getIsAuthenticated",
      "getUser",
      "getUserId",
      "getAppFlow",
      "getQuestions",
      "getSubQuestions",
      "getSections",
      "getActiveQuestion",
      "getActiveSection",
      "getAllAddresses",
      "getAllEmployment",
      "getAppLanguage",
    ]),
    // Steven changes starts - DMA co-brand: the application has a realtor with a headshot (the headshot is required by the card)
    hasCoBrandRealtor() {
      return !!(this.getUser?.realtorName && this.getUser?.realtorHeadshot);
    },
    // Steven changes ends

    currentSectionIndex() {
      return this.getSections.findIndex(
        (y) => y.sectionName === this.getActiveSection
      );
    },

    showSidebarLink() {
      let theQue = this.getQuestions.find(
        (v) =>
          v.questionFieldMapping === "client_scenario__c" ||
          v.questionFieldMapping === "candidoem__client_scenario__c"
      );

      if (theQue) {
        if (
          theQue.questionAnswer === null ||
          theQue.questionAnswer === "" ||
          theQue.questionAnswer === "Repeat Purchase Client"
        )
          return false;
        else {
          let reo_index = this.sidebarSections.findIndex(
            (v) => v.sectionName === "Real Estate Owned"
          );

          if (this.currentSectionIndex > reo_index) {
            return true;
          } else {
            let isVisited;

            for (let i = 0; i < this.sidebarSections.length; i++) {
              if (i < reo_index) {
                isVisited = this.sidebarSections[i].visited;
              } else {
                break;
              }
            }

            if (isVisited && !this.sidebarSections[reo_index].visited)
              return true;
            else return false;
          }
        }
      }

      return false;
    },
  },
  watch: {
    getQuestions: {
      deep: true,
      immediate: true,
      async handler(newVal) {
        if (this.isUpdating) return; // Prevent execution if already updating
        try {
          // Set flag to indicate an update is in progress
          this.isUpdating = true;
          // Await the translation process before continuing
          const translateNewVal = await this.translateFields(newVal);
          // Once translated, update the sidebarQues
          this.sidebarQues = [].concat.apply(translateNewVal, []);
          // After the update, run the nextTick to ensure DOM updates
          this.$nextTick(() => {
            this.updateSectionObject();
            this.updateSidebarSection();
          });
        } catch (error) {
          console.error("Error in translating questions:", error);
        } finally {
          // Reset flag once the update is done
          this.isUpdating = false;
        }
      },
    },
    getAppLanguage: {
      immediate: true,
      deep: true,
      async handler() {
        // Call the translateQuestions method when the language changes
        if (this.isFirstLoad) {
          // Mark the flag as false after the first load
          this.isFirstLoad = false;
        } else {
          const translationSidebarQues = await this.translateFields(
            this.sidebarQues
          );
          this.sidebarQues = [].concat.apply(translationSidebarQues, []);
          await this.updateSidebarSection();
          if (this.getAllAddresses?.length) {
            const addressTranslationData = await this.translateAddressQuestions(
              this.getAllAddresses,
              true
            );
            await this.fetchAllAddresses(addressTranslationData);
          }
          if (this.getAllEmployment.length) {
            const employementTranslationData =
              await this.translateEmploymentQuestions(this.getAllEmployment);
            this.fetchAllEmployment(employementTranslationData || []);
          }
        }
        await this.updateSectionObject();
      },
    },

    getActiveQuestion() {
      this.sidebarQues = [].concat.apply(this.getQuestions, []);

      this.$nextTick(() => {
        this.updateSectionObject();
      });
    },

    getAllAddresses: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.updateSectionObject();
        });
      },
    },
    getAllEmployment: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.updateSectionObject();
        });
      },
    },
  },
  created() {
    eventBus.$on("mobile-view", (data) => {
      this.mobileSideBar = data;
    });
  },
  async mounted() {
    this.sidebarQues = [].concat.apply(this.getQuestions, []);
    this.$nextTick(() => {
      this.updateSectionObject();
      this.updateSidebarSection();
    });
  },
  methods: {
    ...mapActions([
      "fetchActiveQuestion",
      "fetchActiveSection",
      "updateQueObjectWithAnswer",
      "fetchAllAddresses",
      "fetchAllEmployment",
    ]),
    translateText,

    startOfSection(section) {
      let section_name = section.sectionName;

      if (section.visited || section.completed) {
        const first = this.getQuestions.find(
          (v) => v.sectionName === section_name
        );

        this.fetchActiveQuestion(first.questionIndex);
        this.fetchActiveSection(section_name);
      }
    },

    async updateSidebarSection() {
      // Now translate the section names and add translatedSectionName property
      const targetLanguage = this.getAppLanguage;
      try {
        // Collect all the section names that need translation
        const sectionNamesToTranslate = [];
        const sectionMapping = [];

        // Iterate through the sections to gather the section names
        for (const section of this.sidebarSections) {
          if (section.sectionName) {
            sectionNamesToTranslate.push(section.sectionName);
            sectionMapping.push(section); // Store the reference to the section for later use
          }
        }
        // If there are section names to translate, batch translate them
        if (sectionNamesToTranslate.length > 0) {
          const translatedSectionNames = await this.translateTexts(
            sectionNamesToTranslate,
            [],
            targetLanguage
          );

          // Map the translated section names back to the original sections
          translatedSectionNames.forEach((translatedName, index) => {
            const section = sectionMapping[index];
            if (section) {
              section.translatedSectionName =
                translatedName || section.sectionName; // Use translated or fallback to original
            }
          });
        }
        // After translation, update sidebarSections (you may need to call another method here)
        this.sidebarSections = [...this.sidebarSections]; // Re-assign to trigger reactivity in Vue
      } catch (error) {
        console.error("Translation process failed:", error);
      }
    },

    isFirstApiQuestionInSection(que) {
      if (
        que.apiName !== "AddressAPI" &&
        que.apiName !== "EmploymentInfo"
      )
        return true;

      let firstApiQue = this.sidebarQues.find(
        (q) =>
          q.sectionName === que.sectionName &&
          q.apiName === que.apiName &&
          q.showOnSidebar &&
          this.checkQueDependancy(q)
      );

      return !!firstApiQue && firstApiQue.questionIndex === que.questionIndex;
    },

    // Check if a question-level dependency is met (for questions in getQuestions)
    isQuestionApplicable(q) {
      if (!q.dependentQuestionId) return true;
      let parent = this.sidebarQues.find(
        (p) => p.questionId === q.dependentQuestionId
      );
      if (!parent) return true;
      if (parent.questionType === "MultipleChoice") {
        let validAnswers = q.dependentQuestionAnswer
          ? q.dependentQuestionAnswer.split("||")
          : [];
        return (
          parent.questionAnswer?.length &&
          parent.questionAnswer.some((r) => validAnswers.includes(r))
        );
      }
      return parent.questionAnswer === q.dependentQuestionAnswer;
    },

    // Check if a field inside address/employment data is applicable based on local + cross-store dependencies
    isFieldApplicable(field, siblingFields) {
      if (!field.dependentQuestionId && !field.dependentQuestionAnswer)
        return true;

      // First check within same entry (local dependency — same groupName pattern)
      let parent = siblingFields.find(
        (f) => f.questionId === field.dependentQuestionId
      );

      // If parent not in same entry, check getQuestions (cross-store dependency)
      if (!parent) {
        let globalParent = this.sidebarQues.find(
          (p) => p.questionId === field.dependentQuestionId
        );
        if (!globalParent) return true;
        // Cross-store: handle MultipleChoice parent with || separator
        if (globalParent.questionType === "MultipleChoice") {
          let validAnswers = field.dependentQuestionAnswer
            ? field.dependentQuestionAnswer.split("||")
            : [];
          return (
            globalParent.questionAnswer?.length &&
            globalParent.questionAnswer.some((r) => validAnswers.includes(r))
          );
        }
        return globalParent.questionAnswer === field.dependentQuestionAnswer;
      }

      // Local dependency: check within same entry
      if (
        field.dependentQuestionAnswer &&
        field.dependentQuestionAnswer.indexOf("||") > -1
      ) {
        let validAnswers = field.dependentQuestionAnswer.split("||");
        if (Array.isArray(parent.questionAnswer)) {
          return parent.questionAnswer.some((r) => validAnswers.includes(r));
        }
        return validAnswers.includes(parent.questionAnswer);
      }
      return parent.questionAnswer === field.dependentQuestionAnswer;
    },

    async updateSectionObject() {
      this.sidebarSections = [];
      let sectionData = [].concat.apply(this.getSections, []);

      sectionData.forEach((x, i) => {
        // visited: at least one question has an answer OR user has navigated past this section
        x.visited =
          i < this.currentSectionIndex ||
          this.sidebarQues.some(
            (z) =>
              z.sectionName === x.sectionName &&
              z.questionAnswer !== null &&
              z.questionAnswer !== ""
          );

        // completed: all mandatory & applicable questions in this section are answered
        let sectionQuestions = this.sidebarQues.filter(
          (z) => z.sectionName === x.sectionName
        );

        // Check address data for this section (only for applicable address questions)
        let addressQuestions = sectionQuestions.filter(
          (z) =>
            z.apiName === "AddressAPI" &&
            this.isQuestionApplicable(z)
        );
        let addressComplete = true;
        if (addressQuestions.length) {
          let addressSection = this.getAllAddresses.find(
            (a) => a.sectionName === x.sectionName
          );
          if (
            !addressSection ||
            !addressSection.addressDetails ||
            !addressSection.addressDetails.length
          ) {
            addressComplete = false;
          } else {
            addressComplete = !addressSection.addressDetails.some(
              (entry) =>
                entry.addressData &&
                entry.addressData.some(
                  (field) =>
                    field.isMandatory &&
                    this.isFieldApplicable(field, entry.addressData) &&
                    (field.questionAnswer === null ||
                      field.questionAnswer === "" ||
                      field.questionAnswer === undefined)
                )
            );
            // Check 2-year address history
            if (
              addressComplete &&
              (x.sectionName === "Personal Information" ||
                x.sectionName === "Co-Applicant Info")
            ) {
              let twoYearsAgo = moment().subtract(2, "years").format("M/D/YYYY");
              addressComplete = addressSection.addressDetails.some((entry) => {
                let moveInDate = entry.addressData?.find(
                  (f) =>
                    f.questionFieldMapping === "move_in_date__c" ||
                    f.questionFieldMapping === "candidoem__move_in_date__c"
                );
                return (
                  moveInDate?.questionAnswer &&
                  moment(moveInDate.questionAnswer).isBefore(twoYearsAgo)
                );
              });
            }
          }
        }

        // Check employment data for this section (only for applicable employment questions)
        let employmentQuestions = sectionQuestions.filter(
          (z) =>
            z.apiName === "EmploymentInfo" &&
            this.isQuestionApplicable(z)
        );
        let employmentComplete = true;
        if (employmentQuestions.length) {
          let employmentSection = this.getAllEmployment.find(
            (e) => e.sectionName === x.sectionName
          );
          if (
            !employmentSection ||
            !employmentSection.employmentInfoDetails ||
            !employmentSection.employmentInfoDetails.length
          ) {
            employmentComplete = false;
          } else {
            employmentComplete =
              !employmentSection.employmentInfoDetails.some(
                (entry) =>
                  entry.employmentInfoData &&
                  entry.employmentInfoData.some(
                    (field) =>
                      field.isMandatory &&
                      this.isFieldApplicable(field, entry.employmentInfoData) &&
                      (field.questionAnswer === null ||
                        field.questionAnswer === "" ||
                        field.questionAnswer === undefined)
                  )
              );
            // Check 2-year employment history
            if (
              employmentComplete &&
              (x.sectionName === "Annual Income" ||
                x.sectionName === "Co-Applicant Annual Income")
            ) {
              let twoYearsAgo = moment().subtract(2, "years").format("M/D/YYYY");
              employmentComplete = employmentSection.employmentInfoDetails.some(
                (entry) => {
                  let startDate = entry.employmentInfoData?.find(
                    (f) =>
                      f.questionFieldMapping === "start_date__c" ||
                      f.questionFieldMapping === "candidoem__start_date__c"
                  );
                  return (
                    startDate?.questionAnswer &&
                    moment(startDate.questionAnswer).isBefore(twoYearsAgo)
                  );
                }
              );
            }
          }
        }

        // Check regular mandatory questions (non-address, non-employment)
        let mandatoryQuestions = sectionQuestions.filter((z) => {
          if (!z.isMandatory) return false;
          if (z.apiName === "AddressAPI" || z.apiName === "EmploymentInfo")
            return false;
          if (!this.isQuestionApplicable(z)) return false;
          return true;
        });

        let regularComplete =
          mandatoryQuestions.length > 0
            ? mandatoryQuestions.every((z) => {
                // Check primary applicant answer
                if (
                  z.questionAnswer === null ||
                  z.questionAnswer === "" ||
                  (Array.isArray(z.questionAnswer) && z.questionAnswer.length === 0)
                )
                  return false;
                // Check co-applicant answer if co-applicant field is applicable
                if (z.questionCoFieldMapping && z.coDependentQuestionId) {
                  let coParent = this.sidebarQues.find(
                    (p) => p.questionId === z.coDependentQuestionId
                  );
                  if (
                    coParent &&
                    coParent.questionAnswer === z.coDependentQuestionAnswer
                  ) {
                    if (
                      z.coQuestionAnswer === null ||
                      z.coQuestionAnswer === "" ||
                      z.coQuestionAnswer === undefined
                    )
                      return false;
                  }
                }
                return true;
              })
            : true;

        x.completed =
          x.visited && addressComplete && employmentComplete && regularComplete;

        x.hide = false;

        if (x.questionId && x.questionAnswer) {
          x.hide = !this.sidebarQues.some(
            (z) =>
              z.questionId === x.questionId &&
              z.questionAnswer === x.questionAnswer
          );
        }

        if (i > this.currentSectionIndex && !x.visited) x.expand = false;
        else x.expand = true;

        if (!x.hide) this.sidebarSections.push(x);
      });
    },

    forceAddProperty() {
      let parentQue = this.getQuestions.find(
        (v) =>
          v.questionFieldMapping === "client_scenario__c" ||
          v.questionFieldMapping === "candidoem__client_scenario__c"
      );

      if (parentQue) parentQue.questionAnswer = "Repeat Purchase Client";

      let childQue = this.getQuestions.find(
        (v) =>
          v.questionFieldMapping ===
            "do_you_own_any_additional_real_estate__c" ||
          v.questionFieldMapping ===
            "candidoem__do_you_own_any_additional_real_estate__c"
      );

      if (childQue) childQue.questionAnswer = "Yes";

      let theArr = [parentQue, childQue];

      this.updateQueObjectWithAnswer(theArr);

      let payLoad = {
        prospectId: this.getUserId,
        questionsToUpdate: theArr,
        orgId: this.getOrgId,
      };

      this.$http
        .post("/question/prospect/Questions/", payLoad)
        .then(() => {})
        .catch((error) => {
          console.log(error);
        });

      if (childQue) this.fetchActiveQuestion(childQue.questionIndex + 1);
    },

    formTheAddresses(que) {
      if (this.getAllAddresses.length) {
        let currSection = this.getAllAddresses.find(
          (i) => i.sectionName === que.sectionName
        );

        if (currSection) {
          let theArr = currSection.addressDetails;

          if (
            currSection.sectionName === "Personal Information" ||
            currSection.sectionName === "Co-Applicant Info"
          ) {
            let addr = cloneDeep(theArr[0].addressData);

            let x = "";

            addr.forEach((v) => {
              if (v.questionType === "Text") {
                x += ", " + v.questionAnswer;
              }
            });

            return x.substring(1);
          } else {
            let answerArray = [];

            theArr.forEach((x) => {
              let addr = cloneDeep(x.addressData);

              let z = "";

              addr.forEach((k) => {
                if (k.questionType === "Text") {
                  z += ", " + k.questionAnswer;
                }
              });

              answerArray.push(z.substring(1));
            });

            return answerArray;
          }
        }
      }
    },

    formTheEmployment(que) {
      if (this.getAllEmployment.length) {
        let currSection = this.getAllEmployment.find(
          (i) => i.sectionName === que.sectionName
        );

        if (currSection) {
          let theArr = currSection.employmentInfoDetails;

          theArr = theArr.filter(
            (v) => v.detailType === "Employer Information"
          );

          if (theArr.length) {
            let current_date = moment().format("M/D/YYYY");

            let arrOfDays = theArr.map((v) => {
              let date = v.employmentInfoData.find(
                (y) =>
                  y.questionFieldMapping === "start_date__c" ||
                  y.questionFieldMapping === "candidoem__start_date__c"
              );

              if (date?.questionAnswer)
                return moment(current_date).diff(
                  moment(date.questionAnswer),
                  "days"
                );
            });

            // Remove the negative numbers as they future dates
            let newArrOfDays = arrOfDays.filter((x) => {
              return x > -1;
            });

            if (newArrOfDays.length) {
              // Get the smallest positive number from the array
              let the_number = Math.min(...newArrOfDays);

              // returns index of the nearest start date which is before the start date
              let theIndex = arrOfDays.indexOf(the_number) || 0;

              let curr_employer = theArr[theIndex].employmentInfoData;

              let x = "";

              curr_employer.forEach((z) => {
                if (
                  z.questionType === "Text" &&
                  z.questionFieldMapping !== "address__c" &&
                  z.questionFieldMapping !== "candidoem__address__c" &&
                  z.dependentQuestionAnswer === theArr[theIndex].detailType
                ) {
                  x += " | " + z.questionAnswer;
                }
              });

              return x.substring(2) + " Years";
            }
          }
        }
      }
    },

    fetchTheAbbreviation(que) {
      if (this.getAllEmployment.length) {
        let currSection = this.getAllEmployment.find(
          (i) => i.sectionName === que.sectionName
        );

        if (currSection) {
          let theArr = currSection.employmentInfoDetails;

          theArr = theArr.filter(
            (v) => v.detailType === "Employer Information"
          );

          if (theArr.length) {
            let current_date = moment().format("M/D/YYYY");

            let arrOfDays = theArr.map((v) => {
              let date = v.employmentInfoData.find(
                (y) =>
                  y.questionFieldMapping === "start_date__c" ||
                  y.questionFieldMapping === "candidoem__start_date__c"
              );

              if (date?.questionAnswer)
                return moment(current_date).diff(
                  moment(date.questionAnswer),
                  "days"
                );
            });

            // Remove the negative numbers as they future dates
            let newArrOfDays = arrOfDays.filter((x) => {
              return x > -1;
            });

            if (newArrOfDays.length) {
              // Get the smallest positive number from the array
              let the_number = Math.min(...newArrOfDays);

              // returns index of the nearest start date which is before the start date
              let theIndex = arrOfDays.indexOf(the_number) || 0;

              let curr_employer = theArr[theIndex].employmentInfoData;

              let x = "";

              for (let k = 0; k < curr_employer.length; k++) {
                if (
                  curr_employer[k].dependentQuestionAnswer ===
                  theArr[theIndex].detailType
                ) {
                  x = curr_employer[k].sidebarAbbreviationText;
                  break;
                }
              }

              return x + ":";
            }
          }
        }
      }
    },

    checkQueDependancy(que) {
      if (que.dependentQuestionId) {
        let checkIt;

        if (que.apiName === "EmploymentInfo") {
          let arr;

          if (que.dependentQuestionAnswer.indexOf("||") > -1) {
            arr = que.dependentQuestionAnswer.split("||");
          } else {
            arr = que.dependentQuestionAnswer;
          }

          if (typeof arr === "object") {
            checkIt = this.sidebarQues.some(
              (v) =>
                v.questionId === que.dependentQuestionId &&
                v.questionAnswer?.length &&
                v.questionAnswer.some((r) => arr.includes(r))
            );
          }

          if (typeof arr === "string") {
            checkIt = this.sidebarQues.some(
              (v) =>
                v.questionId === que.dependentQuestionId &&
                v.questionAnswer?.length &&
                (Array.isArray(v.questionAnswer)
                  ? v.questionAnswer.includes(arr)
                  : v.questionAnswer === arr)
            );
          }
        } else {
          checkIt = this.sidebarQues.some((v) => {
            if (v.questionId !== que.dependentQuestionId) return false;
            if (Array.isArray(v.questionAnswer)) {
              let validAnswers =
                que.dependentQuestionAnswer &&
                que.dependentQuestionAnswer.indexOf("||") > -1
                  ? que.dependentQuestionAnswer.split("||")
                  : [que.dependentQuestionAnswer];
              return v.questionAnswer.some((r) => validAnswers.includes(r));
            }
            return v.questionAnswer === que.dependentQuestionAnswer;
          });
        }

        return checkIt;
      }

      return true;
    },

    redirectToTheQuestion(que) {
      if (que.groupName) {
        let theFields = [];

        for (let i = que.questionIndex - 1; i > 0; i--) {
          if (
            this.sidebarQues[i].groupName === null ||
            this.sidebarQues[i].groupName !== que.groupName
          ) {
            break;
          }
          theFields.push(this.sidebarQues[i]);
        }

        this.fetchActiveQuestion(theFields.at(-1).questionIndex);
      } else {
        this.fetchActiveQuestion(que.questionIndex);
      }

      this.mobileSideBar = !this.mobileSideBar;
      eventBus.$emit("open-sidebar", this.mobileSideBar);
    },

    skipTheFields(que) {
      let skipIndexes = [];

      for (let i = que.questionIndex; i < this.sidebarQues.length; i++) {
        if (
          this.sidebarQues[i].sidebarAbbreviationText === "" ||
          this.sidebarQues[i].sidebarAbbreviationText !==
            que.sidebarAbbreviationText
        ) {
          break;
        }

        skipIndexes.push(this.sidebarQues[i].questionIndex);
        this.sidebarQues[i].showOnSidebar = false;
      }

      return skipIndexes;
    },

    mergeTheAbbreviationText(que) {
      let theMergedAnswer = " ";

      for (let i = que.questionIndex - 1; i < this.sidebarQues.length; i++) {
        if (
          this.sidebarQues[i].sidebarAbbreviationText === null ||
          this.sidebarQues[i].sidebarAbbreviationText !==
            que.sidebarAbbreviationText
        ) {
          break;
        }

        theMergedAnswer += " " + this.sidebarQues[i].questionAnswer;
      }

      return theMergedAnswer;
    },

    getSubQuestionsAnswers(que, option) {
      let theSubQues = this.getSubQuestions.filter(
        (v) => v.subQuestionOf === que.questionId
      );

      let total = 0;

      for (let i = 0; i < theSubQues.length; i++) {
        if (
          theSubQues[i].optionUndertheSubQuestionAdded === option &&
          theSubQues[i].questionType === "Currency"
        ) {
          if (theSubQues[i].isMonthlyCurrency) {
            total += Number(theSubQues[i].questionAnswer * 12 || 0);
          } else {
            total += Number(theSubQues[i].questionAnswer || 0);
          }
        }
      }

      return "$" + total;
    },
  },
};
</script>

<style scoped>
/* Steven changes starts - DMA co-brand: LO + realtor in the mockup's compact layout, with a divider before the licensing text */
.cobrand-contacts {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.cobrand-contact {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  color: #fff;
}
.cobrand-contact .avatar {
  flex-shrink: 0;
}
.cobrand-contact .avatar img {
  height: 100%;
  object-fit: cover;
}
.cobrand-contact__details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.cobrand-contact__name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #fff;
}
.cobrand-contact__role {
  margin-left: 8px;
  font-size: 13px;
  font-weight: 400;
  opacity: 0.85;
}
.cobrand-contact__details a {
  font-size: 15px;
  line-height: 21px;
  color: #fff;
  text-decoration: none;
  overflow-wrap: anywhere;
}
.cobrand-contact__details a:hover {
  text-decoration: underline;
}
/* the step-list rule (aside .sidebar ul li, opacity 0.7) also dimmed the 2nd contact line; the mockup shows them all white */
.sidebar .user-info ul li {
  opacity: 1;
}
/* Steven changes ends */
.avatar-name {
  display: flex;
  gap: 15px;
  color: white;
}
.sidebar .user-info ul {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sidebar .user-info ul li::after {
  display: none;
}
.lo-other-details {
  margin-left: 25px;
}
.sidebar .user-info ul li {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 0px;
}
.sidebar .user-info ul li a,
.lo-other-details p {
  font-size: 16px;
  font-weight: 400;
  line-height: 21.28px;
  color: #fff;
}
.sub-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: white;
}
.sub-details a {
  color: white;
}
@media (max-width: 767px) {
  .lo-other-details {
    margin-left: 40px;
  }
}
.sidebar .user-info {
  padding-bottom: 10px;
}
.sidebar-legal-links {
  padding: 0 25px 16px;
}
@media (max-width: 767px) {
  .sidebar-legal-links {
    padding: 0 15px 16px 55px;
  }
}

.sidebar-legal-links a {
  color: #ffffff;
  font-size: 12px;
  font-family: "Lato", sans-serif;
  text-decoration: none;
  opacity: 0.75;
  transition: opacity 0.2s;
}

.sidebar-legal-links a:hover {
  opacity: 1;
  text-decoration: underline;
}

.sidebar-legal-separator {
  color: #ffffff;
  font-size: 12px;
  margin: 0 6px;
  opacity: 0.5;
}

aside {
  background-color: var(--primary-color);
}
aside::-webkit-scrollbar-thumb {
  background: var(--primary-color);
}
aside .sidebar ul li .icon::before {
  background: var(--primary-color);
}
.extra-link {
  cursor: pointer;
  color: #ffffff !important;
  font-size: 15px;
  text-decoration: underline;
}
</style>
